import type { GrowthToolFormValues } from '../../pages/Profile/CreateGrowthTool/ZodValidationSchema'

type EditGrowthToolFormValues = Omit<GrowthToolFormValues, 'image'>

const trimStr = (s: string) => s.trim()

const stringArraysEqual = (a: string[], b: string[]) => {
  if (a.length !== b.length) return false
  return a.every((v, i) => v === b[i])
}

export function areGrowthToolFormOutputsEqual(
  a: EditGrowthToolFormValues,
  b: EditGrowthToolFormValues,
): boolean {
  if (trimStr(a.title) !== trimStr(b.title)) return false
  if (trimStr(a.description) !== trimStr(b.description)) return false
  if (!stringArraysEqual(a.source_type, b.source_type)) return false
  if (!stringArraysEqual(a.content_type, b.content_type)) return false
  return true
}

export const isGrowthToolFormUnchanged = (
  current: EditGrowthToolFormValues,
  baseline: EditGrowthToolFormValues,
): boolean => areGrowthToolFormOutputsEqual(current, baseline)
